import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import ImageGallery from "react-image-gallery";
import {withStyles} from "@material-ui/core";
import {slideshow as styles} from "../styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs, {TabPane} from "rc-tabs";
import TabContent from "rc-tabs/lib/TabContent";
import TabBar from "rc-tabs/lib/TabBar";


const SlideShow = ({classes, poiItem}) => {
	const [poiImages, setPoiImages] = useState([]);
	useEffect(() => {
		if (poiItem) {
			const images = poiItem.images.map(image => {
				return {
					original: `./data/district/images/${image}`
				};
			});
			setPoiImages(images);
		}
	}, [poiItem]);
	return (
		<main className={`${classes.mainWrapper} ${classes.poiGallery}`}>
			{poiItem.iframe === "" ?
				<ImageGallery
					items={poiImages}
					showThumbnails={false}
					showFullscreenButton={false}
					showPlayButton={false}
				/>
				:
				<div className={classes.tabs}>
					<Tabs
						defaultActiveKey="1"
						tabBarPosition="bottom"
						renderTabBar={() => <TabBar className={classes.appBar}/>}
						renderTabContent={() => <TabContent/>}
						className={classes.tabs}
					>
						<TabPane tab="Situation" key="1">
							<ImageGallery
								items={poiImages}
								showThumbnails={false}
								showFullscreenButton={false}
								showPlayButton={false}
							/>
						</TabPane>
						<TabPane className={classes.tab} tab="Web" key="2">
							<iframe
								title="Iframe"
								className={classes.iframe}
								src={poiItem.iframe}
								frameBorder="0"
							/>
						</TabPane>
					</Tabs>
				</div>
			}
		</main>
	);
}
;
SlideShow.propTypes =
	{
		images: PropTypes.array.isRequired
	}
;
export default withStyles(styles)(SlideShow);
